import {UAParser} from 'ua-parser-js'

/**
 *  <Desription of Service here>
 *
 * @export
 * @class UserAgentManager
 */
export class UserAgentManager {

  /**
   * $inject to make angular DI minification safe
   *
   * @static
   * @type {Array<string>}
   */
  public static $inject: [string] = ['$log'];
  public parser: any
  public result: any

  /**
   * @param {$log} $log - Angular logging Service.
   */
  constructor(public $log: any) {
    this.$log = $log.getInstance('UserAgentManager', false);
    this.$log.debug('constructor');
    this.parser = new UAParser()
    this.result = this.parser.getResult()
  }

  public getResult() {
    return this.parser.getResult()
  }

  public getDevice() {
    return this.parser.getDevice()
  }

  public getEngine() {
    return this.parser.getEngine()
  }

  public getOS() {
    return this.parser.getOS()
  }

  public getCPU() {
    return this.parser.getCPU()
  }

  public getUA() {
    return this.parser.getUA()
  }

  public getBrowserVersion() {
    return parseInt(this.result.browser.major) || 0
  }

  public isChrome() {
    return this.result.browser.name === 'Chrome'
  }

  public isFirefox() {
    return this.result.browser.name === 'Firefox'
  }

  public isSafari() {
    return this.result.browser.name === 'Safari'
  }

  public isIE() {
    return this.result.browser.name === 'IE'
  }

  public isIE7() {
    return this.isIE() && this.result.browser.major === '7'
  }

  public isIE8() {
    return this.isIE() && this.result.browser.major === '8'
  }

  public isIE9() {
    return this.isIE() && this.result.browser.major === '9'
  }

  public isIE10() {
    return this.isIE() && this.result.browser.major === '10'
  }

  public isIE11() {
    return this.isIE() && this.result.browser.major === '11'
  }

  //TODO: Add Edge Detection

  public isWindows() {
    return this.result.os.name === 'Windows'
  }

  public isWindowsXP() {
    return this.isWindows() && this.result.os.version === 'XP'
  }

  public isWindows7() {
    return this.isWindows() && this.result.os.version === '7'
  }

  public isWindows8() {
    return this.isWindows() && this.result.os.version === '8'
  }

  public isWindows10() {
    return this.isWindows() && this.result.os.version === '10'
  }

  public isOSX() {
    return this.result.os.name === 'Max OS X'
  }

  public isIOS() {
    return this.result.os.name === 'iOS';
  }

  public isAndroid() {
    return this.result.os.name === 'Android';
  }

  public isChromeOS() {
    return this.result.os.name === 'Chromium OS'
  }

  public isMobile() {
    return this.result.device.type === 'mobile'
  }

  public isTablet() {
    return this.result.device.type === 'tablet'
  }

  public isDesktop() {
    return !this.isMobile() && !this.isTablet()
  }

  public isIPhone() {
    return this.result.device.model === 'iPhone'
  }

  public isIPad() {
    return this.result.device.modal === 'iPad'
  }

  public isTouchCapable() {
    let isTouchCapable = false
    if (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)) {
      isTouchCapable = true;
    }
    return isTouchCapable
  }


}



/** WEBPACK FOOTER **
 ** ./src/common/services/user-agent-manager/user-agent-manager.ts
 **/